var _path, _circle, _path2, _circle2, _path3, _circle3, _circle4, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 324,
    viewBox: "0 0 292 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3879 269.185C15.4296 239.03 32.6807 161.885 92.0924 102.473C151.851 42.7143 225.152 29.0308 254.829 56.7434L229.247 82.3259C225.795 80.1971 215.371 76.3871 194.289 81.529C171.7 87.0386 143.694 101.783 117.548 127.929C91.4456 154.031 75.6136 183.344 69.237 207.557C63.7278 228.477 66.4375 239.292 68.2155 243.357L42.3879 269.185Z",
    fill: "#FF5364"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 163,
    r: 117,
    fill: "#955BA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212 73C212 98.4053 191.405 119 166 119C140.595 119 120 98.4053 120 73C120 63.6904 122.766 55.0273 127.52 47.7861C134.17 46.6123 141.013 46 148 46C171.29 46 192.991 52.8057 211.223 64.5361C211.733 67.2793 212 70.1084 212 73ZM191.109 69.0146C193.31 69.209 194.937 71.1504 194.743 73.3506C193.575 86.6025 185.984 94.8213 177.573 99.001C173.419 101.064 169.048 102.16 165.095 102.438C161.233 102.711 157.374 102.227 154.46 100.704C152.501 99.6816 151.743 97.2646 152.766 95.3066C153.789 93.3486 156.205 92.5908 158.163 93.6133C159.289 94.2012 161.5 94.6719 164.533 94.458C167.475 94.251 170.824 93.4209 174.014 91.8359C180.291 88.7178 185.884 82.7461 186.773 72.6484C186.968 70.4482 188.909 68.8213 191.109 69.0146Z",
    fill: "#B49ACA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 153,
    r: 17,
    fill: "#B49ACA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.233 269.168C184.126 275.257 169.703 278.989 154.507 279.822C150.465 275.381 148 269.479 148 263C148 249.193 159.193 238 173 238C186.807 238 198 249.193 198 263C198 265.129 197.734 267.195 197.233 269.168Z",
    fill: "#B49ACA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 187,
    r: 11,
    fill: "#B49ACA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 244,
    cy: 181,
    r: 11,
    fill: "#B49ACA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5303 268.949C72.6851 295.907 149.83 278.656 209.242 219.245C269.001 159.486 282.684 86.1847 254.971 56.5078L230.186 80C232.315 83.4517 235.328 95.9659 230.186 117.048C224.676 139.637 209.932 167.643 183.786 193.789C157.684 219.891 128.371 235.723 104.158 242.1C83.2383 247.609 69.5652 247.778 65.5 246L42.5303 268.949Z",
    fill: "#FF5364"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanet);
export default __webpack_public_path__ + "static/media/planet.a5fd98635f9f230cea50286f7fa6f429.svg";
export { ForwardRef as ReactComponent };